import { Change, OpenAPI } from './Change'

const defaultLicense = { name: '' }

export class UpdateLicenseName extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.license ??= defaultLicense
    document.info.license.name = this.value
  }
}

export class UpdateLicenseURL extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.license ??= defaultLicense
    document.info.license.url = this.value
  }
}
